import environmentBase from '@app/src/environments/environment.base';

export const environment = {
  ...environmentBase,
  production: false,
};
